var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.hideWrapper ? '' : 'c-preview-wrapper'},[_c('img',{staticClass:"img-preview img-thumbnail",class:{ 'img-fit': _vm.fit },attrs:{"src":_setup.source,"alt":_vm.alt,"loading":_vm.lazy ? 'lazy' : undefined},on:{"error":_setup.onErrorHandler}})])
}
var staticRenderFns = []

export { render, staticRenderFns }